import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Button } from '@mui/material';

const SurveyCompletedDialog = ({
    open,
    onClose,
    iCmtEnabled,
    comment,
    onCommentChange,
    onSubmitComment,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    backgroundColor: '#f5f5f5',
                    color: '#333333',
                    textAlign: 'center',
                    fontWeight: 'bold',
                }}
            >
                Survey Completed
            </DialogTitle>
            <DialogContent
                sx={{
                    backgroundColor: '#ffffff',
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        mb: 2,
                        fontSize: '1.1rem',
                        color: '#333333',
                    }}
                >
                    Thank you for completing the survey! Your responses have been successfully submitted.
                </Typography>
                {iCmtEnabled && (
                    <>
                        <Typography
                            variant="body2"
                            sx={{
                                fontStyle: 'italic',
                                color: '#666666',
                                mb: 3,
                            }}
                        >
                            We value your feedback. If you have any additional comments, please let us know:
                        </Typography>
                        <TextField
                            label="Your Comments"
                            placeholder="Write your feedback here..."
                            fullWidth
                            multiline
                            rows={4}
                            value={comment}
                            onChange={(e) => onCommentChange(e.target.value)}
                            variant="outlined"
                            sx={{ mb: 2 }}
                        />
                    </>
                )}
            </DialogContent>
            {iCmtEnabled && (
                <DialogActions
                    sx={{
                        justifyContent: 'center',
                        p: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onSubmitComment}
                        disabled={!comment.trim()} // Disable if the comment is empty
                    >
                        Submit Comment
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            color: '#333',
                            borderColor: '#333',
                            fontWeight: 'bold',
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default SurveyCompletedDialog;
